export const GLOBAL_HSCODES_RESET_STATE = 'GLOBAL_HSCODES_RESET_STATE';
export const GLOBAL_HSCODES_CURRENT_ITEM = 'GLOBAL_HSCODES_CURRENT_ITEM';

export const GLOBAL_HSCODES_REQUEST_LOADING = 'GLOBAL_HSCODES_REQUEST_LOADING';
export const GLOBAL_HSCODES_REQUEST_SUCCESS = 'GLOBAL_HSCODES_REQUEST_SUCCESS';
export const GLOBAL_HSCODES_REQUEST_FAILED = 'GLOBAL_HSCODES_REQUEST_FAILED';

export const GLOBAL_HSCODES_CURRENT_ACTION = 'GLOBAL_HSCODES_CURRENT_ACTION';
export const GLOBAL_HSCODES_RESET_ACTION = 'GLOBAL_HSCODES_RESET_ACTION';